import NavBar from "./NavBar";

type Props = {
  children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#f8f9fb] flex flex-col">
      <NavBar />
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
        <div className="flex justify-center">{children}</div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-auto bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <span className="text-gray-900 text-xs font-semibold tracking-wide">
                WM Partners, LP
              </span>
              <span className="hidden sm:inline text-gray-200">|</span>
              <span className="text-gray-400 text-[11px]">
                21500 Biscayne Blvd., Suite 600, Aventura, FL 33180
              </span>
            </div>
            <div className="flex items-center gap-4 text-[11px] text-gray-400">
              <a
                href="tel:+17542606500"
                className="hover:text-gray-700 transition-colors"
              >
                754-260-6500
              </a>
              <a
                href="mailto:info@wmplp.com"
                className="hover:text-gray-700 transition-colors"
              >
                info@wmplp.com
              </a>
              <span className="text-gray-300">
                &copy; {new Date().getFullYear()}
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
